export default __webpack_public_path__ + "static/media/TopBarGozaresh.51c2a015.svg";